export var AVAILABLE_DISPLAY_MODES = (function () {
    var allDisplayModes = { full: true, compact: true };
    return Object.keys(allDisplayModes);
})();
